const page = {
    type: 'object',
    properties: {
        headerImage: { type: 'string' },
        cardImage: { type: 'string' },
        id: { type: 'integer' },
        dimu_unique_id: { type: 'string' },
        legacyId: { type: 'integer' },
        title: { type: 'string' },
        type: {
            type: 'string',
            enum: [ 'article' ],
            enumNames: [ 'Legg til relatert ressurs' ],
            default: 'article'
        }
    }
};

export default page;
